import { createContext } from 'react';

export default createContext(
  { implementation: 'css' }
);
